import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import {
  FIELD_TYPES,
  IFieldType,
  PREDEFINED_TYPES,
  SCALE_FIELD_TYPE,
} from '../../constants/field-types';

@Component({
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
  ],
  selector: 'siat-switch-type-field',
  template: `
    <mat-form-field appearance="outline" class="w-full" [formGroup]="fieldForm">
      <mat-label>Tipologia elemento </mat-label>
      <mat-select
        placeholder="Tipologia"
        formControlName="type"
        (selectionChange)="onChangeSelect.emit($event)"
      >
        <mat-select-trigger class="flex items-center gap-1">
          <mat-icon class="material-icons-outlined">
            {{ currentFieldType?.icon }}
          </mat-icon>
          <div>
            {{ currentFieldType?.descrizione }}
          </div>
        </mat-select-trigger>

        @for (type of fieldTypes; track type) {
          <mat-option [value]="type?.type">
            <mat-icon class="material-icons-outlined">{{ type?.icon }}</mat-icon
            >{{ type.descrizione }}
          </mat-option>
        }
        <mat-optgroup label="Predefiniti">
          <ng-container>
            @for (scale of predefinedTypes; track scale) {
              <mat-option [value]="scale?.type">
                <mat-icon class="material-icons-outlined">{{
                  scale?.icon
                }}</mat-icon
                >{{ scale?.descrizione }}
              </mat-option>
            }
          </ng-container>
        </mat-optgroup>

        <mat-optgroup label="Scale">
          <ng-container>
            @for (scale of scaleFieldsType; track scale) {
              <mat-option [value]="scale?.type">
                <mat-icon>{{ scale?.icon }}</mat-icon
                >{{ scale?.descrizione }}
              </mat-option>
            }
          </ng-container>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>
  `,
})
export class SwitchTypeFieldComponent {
  /**
   * The form group of the current field.
   */
  @Input()
  fieldForm: FormGroup;

  /**
   * The available field types.
   */
  readonly fieldTypes = FIELD_TYPES;
  readonly scaleFieldsType = SCALE_FIELD_TYPE;
  readonly predefinedTypes = PREDEFINED_TYPES;

  /**
   * Emits an event when the field type is changed.
   */
  @Output()
  onChangeSelect = new EventEmitter<MatSelectChange>();

  /**
   * The map of field types.
   */
  private readonly typeMap = new Map(
    [...FIELD_TYPES, ...SCALE_FIELD_TYPE, ...PREDEFINED_TYPES].map(t => [
      t.type,
      t,
    ])
  );

  /**
   * @returns {IFieldType | undefined}
   */
  get currentFieldType(): IFieldType | undefined {
    const typeValue = this.fieldForm?.get('type')?.value;
    return this.typeMap.get(typeValue);
  }
}
